import React from 'react';
import { Document,Page, View ,Text, Image} from '@react-pdf/renderer'; 
import { styles } from '../../../Layout/styleSheet';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();

const PedidoPDF = ({order}) => {
    const profile = {
        type: 'Profile',
        recibo: order.sucursal.id,
        name: order.sucursal.nombre_sucursal,
        direccion: order.sucursal.domicilio,
        telefono1: order.sucursal.telefono1,
        telefono2: order.sucursal.telefono2,
        telefono3: order.sucursal.telefono3,
        fecha: today,
        profileImageURL: '/images/logo.png',
        display: true,
        about: 'About...',
        id: 1,
        fechaAltaEmpleado:'19/09/2006',
        paciente: order.patient.nombre,
        entrega: order.fecha_entrega,
    };

    const HeaderLogo = () => {
        return (
            <View style={styles.col_2}>
                <Image style={styles.logo} src={profile.profileImageURL} />
            </View>
        )
    }  
    const Header = () => {
        return (
            <View style={styles.col_6}>
                <Text style={styles.label}> Sucursal </Text>
                <Text style={styles.subtext}> {profile.name} </Text>
                <Text style={styles.subtext}> {profile.direccion} </Text>
                <Text style={styles.subtext}>Tel. {profile.telefono1}, {profile.telefono2} y {profile.telefono3}</Text>
            </View>
        ) 
    }  
    const HeaderTime = () => {
        return (
            <View style={[styles.col_1, styles.pad_5]}>
                <Text style={styles.label}> Fecha </Text>
                <Text style={styles.subtext}> {profile.fecha} </Text>
            </View>
        )
    }  
    const HeaderDate = () => {
        return (
            <View style={[styles.col_2, styles.pad_5]}>
                <Text style={[styles.label,{textAlign:'right'}]}> No. de Recibo </Text>
                <Text style={[styles.subtext,{textAlign:'right'}]}>  {profile.recibo}  </Text>
            </View>
        )
    } 
    const Divicion = () => {
        return (
            <View style={styles.col_12}>
                <View style={[styles.hr, { color: 'white' }]}>
                    <Text>.</Text>
                </View>
            </View>
        )
    } 

    



    return (
    <Document>
        {/* Start of the document*/}
        <Page size={'A4'} orientation={'landscape'} style={styles.page}>
            <View>
                <View style={styles.row}>
                    <HeaderLogo about={profile.about}></HeaderLogo>
                    <Header about={profile.about}></Header>
                    <HeaderTime about={profile.about}></HeaderTime>
                    <HeaderDate about={profile.about}></HeaderDate>
                </View>
                <View style={styles.row}>
                    <Divicion about={profile.about}></Divicion>
                </View>
                
                <View style={styles.row}>
                    <View style={[styles.col_3, {padding:'5px', textAlign:'right'}]}>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Cliente: </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={styles.label}> {profile.paciente} </Text>
                        </View>
                    </View>
                    <View style={[styles.col_9, {padding:'5px', textAlign:'left'}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Fecha de Entrega: </Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={styles.label}> {profile.entrega} </Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Horario de entrega de estudios: </Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={styles.label}> Luneas a Viernes </Text>
                            <Text style={styles.label}> de 9:00am a 13:00pm y 16:00pm a 19:00pm </Text>
                            <Text style={styles.label}> Sabadors de 9:00 a 13:30 </Text>
                        </View>
                    </View>
                </View>
                
                <View style={styles.row}>
                    <Divicion about={profile.about}></Divicion>
                </View>


                {order.order_details.map ( orden =>
                <View style={styles.row}>
                    <View style={[styles.col_1, {padding:'2px', textAlign:'right'}]}>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Cant: </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={styles.label}> {orden.cantidad} </Text>
                        </View>
                    </View>
                    <View style={[styles.col_6, {padding:'2px', textAlign:'right'}]}>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Descripcion: </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={styles.label}>  {orden.product.nombre_producto} </Text>
                        </View>
                    </View>
                    <View style={[styles.col_2, {padding:'2px', textAlign:'right'}]}>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> P Unitario: </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={styles.label}> $ {orden.precio_unidad} </Text>
                        </View>
                    </View>
                    <View style={[styles.col_2, {padding:'2px', textAlign:'right'}]}>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.labelMini,{textAlign:'right'}]}> Importe: </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={styles.label}> $ - </Text>
                        </View>
                    </View>
                </View>
            )}


                <View style={styles.row}>
                    <View style={[styles.col_1, {padding:'5px', textAlign:'right'}]}> </View>
                    <View style={[styles.col_6, styles.pad_10]}> 
                         <View style={[styles.row, styles.pad_10]}>
                            <View style={[styles.col_8, styles.pad_8]}>
                                <View style={[styles.row, styles.pad_8]}>
                                    <View style={[styles.row, styles.pad_1, styles.losBorders]}>
                                    <View style={[styles.row, styles.losBorders, styles.pad_5]}>
                                        <View style={[styles.row]}>  
                                            <View style={[styles.col_6]}>  
                                                <Text style={[styles.labelMini, styles.pad_3,{fontWeight: 700}]}> Importe Total del pedido </Text>
                                            </View>
                                            <View style={[styles.col_4]}>  
                                                <Text style={[styles.label,]}> 349 </Text>
                                            </View>
                                        </View>
                                        <View style={[styles.col_6]}> 
                                            <Text style={[styles.labelMini, styles.pad_3,{fontWeight: 700}]}> Su pago </Text>
                                            <Text style={[styles.label, styles.pad_0_5]}> 349 </Text>
                                        </View>
                                        <View style={[styles.col_6]}>
                                            <Text style={[styles.labelMini, styles.pad_3,{fontWeight: 700}]}> Saldo </Text>
                                            <Text style={[styles.label, styles.pad_0_5]}> 349 </Text>
                                        </View>
                                    </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.col_2]}>
                        <View style={[styles.row]}>
                            <Divicion about={profile.about}></Divicion>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <View style={[styles.col_6, {textAlign:'right'}]}> </View>
                            <View style={[styles.col_6, {textAlign:'right'}]}>
                                <Text style={[styles.labelBig, styles.pad_3,{textAlign:'right', fontWeight: 700}]}> Subtotal</Text>
                            </View>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <View style={[styles.col_6, {textAlign:'right'}]}> </View>
                            <View style={[styles.col_6, {textAlign:'right'}]}>
                                <Text style={[styles.labelBig, styles.pad_3,{textAlign:'right', fontWeight: 700}]}> Total</Text>
                            </View>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <View style={[styles.col_6, {textAlign:'right'}]}> </View>
                            <View style={[styles.col_6, {textAlign:'right'}]}>
                                <Text style={[styles.labelBig, styles.pad_3,{textAlign:'right', fontWeight: 700}]}> Envio</Text>
                            </View>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <View style={[styles.col_6, {textAlign:'right'}]}> </View>
                            <View style={[styles.col_6, {textAlign:'right'}]}>
                                <Text style={[styles.labelBig, styles.pad_3,{textAlign:'right', fontWeight: 700}]}> TOTAL</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.col_2]}>
                        <View style={styles.row}>
                            <Divicion about={profile.about}></Divicion>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.money, styles.pad_3, {fontWeight: 700}]}> $ {order.order_payment.subtotal} </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.money, styles.pad_3, {fontWeight: 700}]}> $ {order.order_payment.total} </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.money, styles.pad_3, {fontWeight: 700}]}>  $ - </Text>
                        </View>
                        <View style={[styles.row,{textAlign:'right'}]}>
                            <Text style={[styles.money, styles.pad_3, {fontWeight: 700}]}> $ 349.00 </Text>
                        </View>
                    </View>
                </View>
                
            </View>
        </Page>
    </Document>
    );
};

export default PedidoPDF;